"use client";

import type { EappStatusCardData } from "../../types/insurabot-cards";

const S =
  "rgba(0,0,0,0.06) 0px 0px 0px 1px, rgba(0,0,0,0.03) 0px 1px 2px, rgba(0,0,0,0.02) 0px 4px 12px -2px";

function statusColor(status?: string): string {
  if (!status) return "text-gray-600 bg-gray-50";
  const s = status.toLowerCase();
  if (s.includes("approved") || s.includes("issued") || s.includes("active"))
    return "text-emerald-700 bg-emerald-50";
  if (s.includes("declined") || s.includes("withdrawn") || s.includes("cancel"))
    return "text-red-700 bg-red-50";
  if (s.includes("pending") || s.includes("review") || s.includes("requirement"))
    return "text-amber-700 bg-amber-50";
  return "text-gray-700 bg-gray-50";
}

export default function EappStatusCard({ data }: { data: EappStatusCardData }) {
  if (!data?.cases || data.cases.length === 0) return null;
  return (
    <div className="mt-3 rounded-lg overflow-hidden" style={{ boxShadow: S }}>
      <div className="bg-white px-4 py-3">
        <p className="text-[9px] font-bold text-gray-400 uppercase tracking-[0.1em] mb-2">
          Application status
        </p>
        <div className="space-y-2">
          {data.cases.map((c) => (
            <div
              key={c.caseId}
              className="rounded-md p-2 flex items-center justify-between gap-3"
              style={{ boxShadow: S }}
            >
              <div className="min-w-0">
                <p className="text-[11px] font-semibold text-gray-900 truncate">
                  {c.carrier || "Carrier"} — {c.product || "Product"}
                </p>
                {c.reason && (
                  <p className="text-[10px] text-gray-500 truncate">{c.reason}</p>
                )}
                {c.updatedOn && (
                  <p className="text-[9px] text-gray-400">
                    Updated {new Date(c.updatedOn).toLocaleString()}
                  </p>
                )}
              </div>
              <span
                className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${statusColor(c.status)}`}
              >
                {c.status || "Unknown"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
